export default {
  Primary: 'Primary',
  Recent: 'Recent',
  All: 'All',
  'Same Visit ID': 'Same Visit Number',
  'Same Modality': 'Same Modality',
  'Same Procedure': 'Same Procedure',
  History: 'History',
  'Patient Info': 'Patient Info',
  'Exams': 'Exams'
};
